import { MISTYPED_EMAIL_DOMAINS } from './mistyped-email-domains';
export const getSuggestedEmail = (email)=>{
    const trimmed = email.trim();
    const atIndex = trimmed.lastIndexOf('@');
    if (atIndex <= 0 || atIndex === trimmed.length - 1) {
        return null;
    }
    const localPart = trimmed.slice(0, atIndex);
    const domain = trimmed.slice(atIndex + 1).toLowerCase();
    const correctDomain = MISTYPED_EMAIL_DOMAINS.get(domain);
    return correctDomain ? `${localPart}@${correctDomain}` : null;
};

//# sourceMappingURL=get-suggested-email.js.map